import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    hh: Math.floor(seconds / 3600),
    mm: Math.floor(seconds % 3600 / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="relative z-10 flex flex-col items-center" data-id="element-35" data-mp="3h0z593inxt0r">
      <div className="animate-pulse-alert flex h-16 w-16 items-center justify-center rounded-xl border border-alert/50 bg-white font-display text-3xl font-black tabular-nums text-plum sm:h-20 sm:w-20 sm:text-4xl" style={{
      fontFamily: "Montserrat, sans-serif"
    }} data-id="element-36" data-mp="3h2jzst4z9bym">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-plum/50" data-id="element-37" data-mp="10aimw34dwj7b">
        {label}
      </span>
    </div>;
}
type Props = {
  spotsTaken?: number;
};
export function Countdown({
  spotsTaken = 93
}: Props) {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 26);
  return <section aria-label="Countdown" className="relative w-full overflow-x-hidden bg-transparent" data-id="element-38" data-mp="17qq5ck5fk7no">
      
    </section>;
}